module.exports = __webpack_public_path__ + "img/goldregen-2020-078.8107603a.jpg";